'use client';
import { ICompareResponse, TCompareMessage } from '@/lib/tabularCompareApi';
import SchemaView from './SchemaView';
import Card from '@/ui/Card';
import KeyEditor from '@/components/CompareTabular/KeyEditor';
import useDataframeContext from '../../DataframeContext';

import * as Styled from './styled';

const Messages: React.FC<{ messages?: TCompareMessage[] }> = ({ messages = [] }) => {
  return (
    <Styled.Messages>
      {messages.map((message, idx) => (
        <Card.Warning key={idx} snug gap={5}>
          <h6>Warning: {message.title}</h6>
          <p>{message.description}</p>
        </Card.Warning>
      ))}
    </Styled.Messages>
  );
};

const SchemaDetails: React.FC<{}> = ({}) => {
  const { repository, compareResponse } = useDataframeContext();
  const serverMessages = compareResponse?.messages;
  const hasServerMessages = !!serverMessages?.length;

  return (
    <Styled.SchemaScrollWrapper>
      {compareResponse ? (
        <KeyEditor repository={repository} compareResponse={compareResponse as ICompareResponse}>
          {hasServerMessages && <Messages messages={serverMessages} />}
        </KeyEditor>
      ) : (
        <SchemaView />
      )}
    </Styled.SchemaScrollWrapper>
  );
};

export default SchemaDetails;
